import {request, _urlAdvertisement} from "../api";
import {ADVERTISEMENT_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetAdvertisements = () => {
    const requestData = {
        url: `${_urlAdvertisement}`,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: ADVERTISEMENT_CONSTS.GET_ADVERTISEMENTS,
                    payload: data
                });
            })
    }
};



export const GetAdvertisementById = (id) => {
    const requestData = {
        url: `${_urlAdvertisement}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
               return res.data
            })
    }
};
export const DeleteAdvertisementById = ( id) => {
    const requestData = {
        url:  `${_urlAdvertisement}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: ADVERTISEMENT_CONSTS.DELETE_ADVERTISEMENT_BY_ID,
                    payload: id
                });
            })
            .catch(() => {})
    }
};

export const CreateAdvertisement = data => {
    const requestData = {
        url: _urlAdvertisement,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Գովազդը հաջողությամբ ստեղծվեց!"
                })
                history.push('/advertisement')
            })
    }
};

export const UpdateAdvertisementById = (id, data) => {
    const requestData = {
        url: `${_urlAdvertisement}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Գովազդը հաջողությամբ փոփոխվեց!"
                })
                history.push('/advertisement')
            })
    }
};

export const UpdateAdvertisementsPositions = items => {
    const requestData = {
        url: _urlAdvertisement,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                notificationSuccess({
                    description: "Գովազդը հաջողությամբ թարմացվեց!"
                })
            })
    }
};
